import { usePathname, useRouter } from 'next/navigation';

export const useIsActiveRoute = (path: string): { isActive: boolean } => {
  const asPath = usePathname();
  // const { pathname, asPath, query } = useRouter();

  const isActive = asPath === path;

  return { isActive };
};
